import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Chi Siamo', path: '/chi-siamo' },
    { name: 'Servizi', path: '/servizi' },
    { name: 'Prodotti', path: '/prodotti' },
    { name: 'Come Lavoriamo', path: '/come-lavoriamo' },
    { name: 'Galleria', path: '/galleria' },
    { name: 'Contatti', path: '/contatti' }
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-sisaline">
      <div className="footer-content container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_1339b4ee-79eb-48d1-9f64-307ac7401951/artifacts/shomcg6m_Logo3.jpg" 
                alt="SI.SA. LINE S.r.l." 
                className="footer-logo-image"
              />
              <div>
                <div className="footer-logo-name">{companyInfo.name}</div>
                <div className="footer-logo-tagline">{companyInfo.tagline}</div>
              </div>
            </div>
            <p className="footer-description">{companyInfo.description}</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Link Rapidi</h3>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="footer-link"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} {companyInfo.name}. Tutti i diritti riservati.
          </p>
          <div className="footer-legal">
            <a href="#privacy" className="footer-legal-link">Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="#terms" className="footer-legal-link">Termini di Servizio</a>
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer-sisaline {
          background: var(--bg-section-alternate);
          border-top: 3px solid var(--brand-blue);
          padding: var(--space-lg) 0 var(--space-md);
        }

        .footer-content {
          display: flex;
          flex-direction: column;
          gap: var(--space-lg);
        }

        .footer-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--space-lg);
        }

        @media (max-width: 640px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: var(--space-md);
          }
        }

        .footer-section {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 0.5rem;
        }

        .footer-logo-image {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }

        .footer-logo-name {
          font-weight: 800;
          font-size: 1.25rem;
          color: var(--text-primary);
          letter-spacing: 0.02em;
        }

        .footer-logo-tagline {
          font-size: 0.75rem;
          color: var(--text-secondary);
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .footer-description {
          color: var(--text-secondary);
          font-size: 0.95rem;
          line-height: 1.6;
        }

        .footer-title {
          font-weight: 700;
          font-size: 1.125rem;
          color: var(--text-primary);
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .footer-links {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .footer-link {
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 0.95rem;
          transition: color 0.3s ease;
          display: inline-block;
        }

        .footer-link:hover {
          color: var(--brand-orange);
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: var(--space-md);
          border-top: 1px solid var(--border-light);
          flex-wrap: wrap;
          gap: 1rem;
        }

        @media (max-width: 640px) {
          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }
        }

        .footer-copyright {
          color: var(--text-muted);
          font-size: 0.875rem;
        }

        .footer-legal {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .footer-legal-link {
          color: var(--text-muted);
          text-decoration: none;
          font-size: 0.875rem;
          transition: color 0.3s ease;
        }

        .footer-legal-link:hover {
          color: var(--brand-orange);
        }

        .footer-separator {
          color: var(--text-muted);
        }
      `}</style>
    </footer>
  );
};

export default Footer;
